import React from 'react';
import PropTypes from 'prop-types';
import {
  Heading,
  FormikField,
  FormikError,
  Text,
  TextInput,
  Box,
  Flex,
  rem,
} from '@feast-it/pesto';

const Quantity = ({ heading, description, label }) => {
  return (
    <Flex alignItems="center" flexDirection="column">
      <Box width="100%" maxWidth={620}>
        {heading && (
          <Heading
            as="h2"
            textAlign="center"
            variant={{ _: 'headingLargeMobile', m: 'headingLarge' }}
            color="blueDark"
            mb={0}
            fontWeight={500}
          >
            {heading}
          </Heading>
        )}

        {description && (
          <Text
            fontFamily="body"
            color="blueDark"
            fontSize="headingSmall"
            mt={2}
            mb={0}
            textAlign="center"
          >
            {description}
          </Text>
        )}
      </Box>

      <Flex justifyContent="center" alignItems="center" mt={10}>
        <FormikField
          as={TextInput}
          name="request.item_quantity"
          color="blueDark"
          type="number"
          min={0}
          variant="togather"
          size="l"
          width={rem(160)}
          showError={false}
          pattern="[0-9]*"
          suffix={
            label && (
              <Text fontFamily="body" color="blueDark" mb={0}>
                {label}
              </Text>
            )
          }
          testId="quantity-input"
        />
      </Flex>

      <FormikError
        mt={2}
        name="request.item_quantity"
        textAlign="center"
        color="redDark"
        fontSize="small"
        lineHeight="small"
        fontFamily="body"
        fontWeight="heading"
        testId="quantity-input-error"
      />
    </Flex>
  );
};

Quantity.defaultProps = {
  heading: null,
  description: null,
};

Quantity.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default Quantity;
